/* ══════════════════════════════════════════════════════════════════════
   PREVIEW-PANIER.JS — APERÇU LOCAL UNIQUEMENT. NE PAS LIVRER.

   Sur une boutique, le panier appartient à Shopify : il vit dans un
   cookie, survit aux rechargements, se retrouve d'un onglet à l'autre,
   et se vide tout seul quand la commande est passée. Le thème ne fait
   que l'afficher — cart.items dans snippets/cart-drawer.liquid.

   Ici il n'y a pas de boutique : les deux articles sont écrits dans le
   HTML, donc chaque rechargement les remet. Ce fichier tient la même
   mémoire dans localStorage, le temps de voir le comportement réel.

   Il n'a AUCUN équivalent à écrire en Liquid : sur Shopify, tout ce que
   fait ce fichier est déjà fait, et mieux. build.sh ne package que
   theme/ — pas une ligne ne part dans le zip.

   Règle tenue : aucune phrase destinée à l'écran n'est écrite ici. Les
   lignes sont recopiées depuis le balisage de la page, déjà traduit.
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var CLE = 'preview-panier';

  function lire() {
    try { return JSON.parse(localStorage.getItem(CLE) || 'null'); }
    catch (e) { return null; }
  }
  function ecrire(articles) {
    try { localStorage.setItem(CLE, JSON.stringify(articles)); } catch (e) {}
  }
  function vider() {
    try { localStorage.setItem(CLE, '[]'); } catch (e) {}
  }

  /* Une ligne de panier, réduite à ce qui la définit. Le total affiché
     n'en fait pas partie : il se recalcule à partir du prix et de la
     quantité, et deux sources pour un même nombre finissent toujours
     par se contredire. */
  function serialiser(ligne) {
    function texte(sel) {
      var el = ligne.querySelector(sel);
      return el ? el.textContent.trim() : '';
    }
    var img = ligne.querySelector('[data-line-img]');
    return {
      cle:      ligne.dataset.cle || '',
      nom:      texte('[data-line-nom]'),
      variante: texte('[data-line-variante]'),
      photo:    img ? img.getAttribute('src') : '',
      prix:     parseInt(ligne.dataset.price, 10) || 0,
      qte:      parseInt(ligne.dataset.qty, 10) || 1
    };
  }

  function conteneurs() {
    /* Le tiroir est sur les 20 pages ; la page panier ajoute sa propre
       liste. Les deux montrent le même panier, donc les deux se
       remplissent depuis la même mémoire. */
    return [].filter.call(
      document.querySelectorAll('.cart-body, .cmd-lignes'),
      function (c) { return c.querySelector('[data-line]'); }
    );
  }

  function dessiner(boite, articles, modele) {
    [].forEach.call(boite.querySelectorAll('[data-line]'), function (l) { l.remove(); });

    articles.forEach(function (a, rang) {
      var l = modele.cloneNode(true);
      l.style.setProperty('--i', rang);
      l.dataset.qty = a.qte;
      l.dataset.price = a.prix;
      if (a.cle) l.dataset.cle = a.cle; else delete l.dataset.cle;

      var nom = l.querySelector('[data-line-nom]');
      if (nom) nom.textContent = a.nom;
      var vari = l.querySelector('[data-line-variante]');
      if (vari) vari.textContent = a.variante;
      var img = l.querySelector('[data-line-img]');
      if (img && a.photo) img.setAttribute('src', a.photo);
      var n = l.querySelector('[data-qty-value]');
      if (n) n.textContent = a.qte;

      /* Chaque ligne se pose avant le message « panier vide », qui doit
         rester le dernier enfant de la boîte. */
      var vide = boite.querySelector('.cart-empty');
      if (vide) boite.insertBefore(l, vide); else boite.appendChild(l);
    });
  }

  function demarrer() {
    var boites = conteneurs();
    if (!boites.length) return;

    /* Le modèle est prélevé dans le balisage livré : ses boutons et
       leurs libellés sont déjà passés par le traducteur. */
    var modeles = boites.map(function (b) {
      return b.querySelector('[data-line]').cloneNode(true);
    });

    var articles = lire();
    if (articles === null) {
      /* Première visite : le panier de démonstration écrit dans la page
         devient l'état de départ, et n'est plus jamais réimposé. */
      articles = [].map.call(boites[0].querySelectorAll('[data-line]'), serialiser);
      ecrire(articles);
    }

    boites.forEach(function (b, i) { dessiner(b, articles, modeles[i]); });

    /* On observe plutôt qu'on n'écoute les clics : le module du panier
       modifie data-qty et retire des lignes lui-même, et un observateur
       n'a pas à savoir dans quel ordre les scripts se sont câblés.

       L'observateur se débranche le temps de redessiner. Sans ça, le
       redessin déclencherait l'observateur, qui redessinerait — la
       boucle est immédiate et sans fin. Un simple drapeau ne suffit pas :
       les mutations sont livrées après le tour de boucle, donc après
       qu'on l'aurait rabaissé. */
    function brancher() {
      boites.forEach(function (b) {
        obs.observe(b, { childList: true, subtree: true,
                         attributes: true, attributeFilter: ['data-qty'] });
      });
    }

    var obs = new MutationObserver(function () {
      obs.disconnect();

      var etat = [].map.call(boites[0].querySelectorAll('[data-line]'), serialiser);
      ecrire(etat);

      /* La page panier et le tiroir montrent le même panier : ce qui
         change dans l'un doit se voir dans l'autre, totaux compris. */
      boites.forEach(function (b, i) {
        if (b === boites[0]) return;
        dessiner(b, etat, modeles[i]);
        var racine = b.closest('.cart') || b.closest('[data-section]');
        if (racine && racine.__majPanier) racine.__majPanier();
      });

      brancher();
    });

    brancher();

    /* Payer vide le panier — c'est ce que fait Shopify une fois la
       commande passée. Sans ça, on reviendrait sur la boutique avec les
       articles qu'on vient d'acheter encore dedans. */
    document.addEventListener('click', function (e) {
      var payer = e.target.closest('[name="checkout"], [data-checkout]');
      if (!payer) return;
      e.preventDefault();
      vider();
      location.href = 'preview.html';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
